import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FavoriteItemsComponent } from './favorite-items.component';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.favoriteItems.pageInRouting,
    data: {data:PAGES_AND_PATHS.favoriteItems},
    component: FavoriteItemsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./favorite-items.module').then(m => m.FavoriteItemsModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FavoriteItemsRoutingModule { }
